<template>
  <section class="hk-industry">
    <TitleHeader title="热门行业板块" />
    <div class="industry-scroll" v-loading="loading && !industries.length" element-loading-background="var(--theme-bg)">
    <table>
      <thead><tr><th>热门行业</th><th>最新价</th><th>领涨股</th><th>涨跌幅</th></tr></thead>
      <tbody>
        <tr v-for="item in sharedStockRows(industries, 'hk', 'leader')" :key="item.bd_code || item.bd_name" class="industry-row" tabindex="0" @click="selectedIndustry = item" @keydown.enter.self="selectedIndustry = item" @keydown.space.self.prevent="selectedIndustry = item">
          <td :title="item.bd_name"><button class="industry-link" type="button" @click.stop="selectedIndustry = item">{{ item.bd_name }}</button></td>
          <td>{{ price(item.nzg_zxj) }}</td>
          <td :title="item.nzg_name">{{ item.nzg_name || '--' }}</td>
          <td :class="changeClass(item.nzg_zdf)">{{ percent(item.nzg_zdf) }}</td>
        </tr>
        <tr v-if="error"><td colspan="4">{{ error }} <button type="button" @click="load">重试</button></td></tr>
        <tr v-else-if="!loading && !industries.length"><td colspan="4">暂无行业数据</td></tr>
      </tbody>
    </table>
    </div>
    <HongKongIndustryDialog :active="active" :industry="selectedIndustry" @close="selectedIndustry = null" @select-stock="selectStock" />
  </section>
</template>

<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import TitleHeader from '../../home/components/titleHeader.vue'
import HongKongIndustryDialog from './HongKongIndustryDialog.vue'
import { getHongKongIndustries } from '../api'
import { pollMarket } from '@/utils/marketRefresh'

export default {
  name: 'HongKongIndustryPanel',
  components: { TitleHeader, HongKongIndustryDialog },
  props: { active: { type: Boolean, default: true } },
  data() { return { selectedIndustry: null, industries: [], loading: false, error: '', requestId: 0 } },
  watch: { active(value) { if (value) this.activate(); else this.stopPolling() } },
  mounted() { if (this.active) this.activate() },
  beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
  methods: {
    sharedStockRows,
    price: quotePrice,
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || !this.active || this.stopRefresh) return
      try { await this.load(!this.industries.length) }
      finally {
        if (!this.disposed && this.active && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.load(false), 'hk')
      }
    },
    selectStock(item) { this.selectedIndustry = null; this.$emit('select-stock', item) },
    async load(initial = true) {
      if (this.disposed || !this.active || this.loading) return
      initial = initial !== false
      const requestId = ++this.requestId
      this.loading = true
      this.error = ''
      try {
        let industries = await getHongKongIndustries(initial)
        if (requestId !== this.requestId) return
        if (!Array.isArray(industries)) throw new Error('invalid response')
        if (!initial) {
          const previous = new Map(this.industries.map(item => [item.bd_code, item]))
          industries = industries.map(item => ({ ...item, nzg_zxj: item.nzg_zxj == null ? (previous.get(item.bd_code) || {}).nzg_zxj : item.nzg_zxj }))
        }
        this.industries = industries
        // include_quote=1 already supplies leader prices; do not request them twice.
      } catch (error) {
        if (requestId === this.requestId) this.error = '行业加载失败'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    percent: quotePercent,
    changeClass(value) { return Number(value) < 0 ? 'fall' : Number(value) > 0 ? 'rise' : '' }
  }
}
</script>

<style scoped>
.hk-industry { min-width: 0; min-height: 0; display: flex; flex-direction: column; background: var(--theme-bg); color: var(--theme-label); }
.industry-scroll { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #c1c1c1 #eee; }
table { width: 100%; table-layout: fixed; border-collapse: collapse; text-align: center; }
th, td { height: 31px; padding: 0 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: normal; }
th { position: sticky; top: 0; z-index: 1; background: var(--theme-bg); color: var(--theme-label); }
.industry-link { width: 100%; padding: 0; border: 0; background: transparent; color: inherit; font: inherit; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; cursor: pointer; }
.industry-row { cursor:pointer; }.industry-row:focus-visible { outline:2px solid var(--theme-accent); outline-offset:-2px; }
.rise { color: var(--quote-up); } .fall { color: var(--quote-down); }
</style>
